import React, { CSSProperties } from 'react';

import './GridGroupEvent.scss';
import { GroupEventElement } from './GridBody';
import { BubbleBadge } from './BubbleUI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getBasicTimeString } from '@go-shared/lib/event';

export interface CSSPropertiesWithVars extends CSSProperties {
  '--buffer-start'?: string;
  '--buffer-end'?: string;
  '--event-duration-end'?: string;
  '--backgroundColor'?: string;
}

const BACKGROUND_COLOR_APPROVED = '#547c5e';
const BACKGROUND_COLOR_MODIFIED = '#f5b700';

function EVENT_BORDERS(color: string, buffer: boolean = false) {
  return buffer
    ? {
        borderRight: `solid thin ${color}`,
      }
    : {
        borderBottom: `solid thin ${color}`,
        borderRight: `solid thin ${color}`,
      };
}

function GridGroupEvent(props: GroupEventElement) {
  let backgroundImage =
    props.groupEvent.status === 'approved'
      ? `url("data:image/svg+xml,` +
        `%3Csvg%20id%3D'stripes-svg'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20width%3D'100%25'%20height%3D'100%25'%3E%3Cdefs%3E%3Cpattern%20id%3D'svg-stripes-pattern-7515'%20patternTransform%3D'rotate(45)'%20width%3D'100%25'%20height%3D'4'%20x%3D'0'%20y%3D'0'%20patternUnits%3D'userSpaceOnUse'%3E%3Cg%3E%3Crect%20x%3D'0'%20y%3D'0'%20width%3D'100%25'%20height%3D'2'%20fill%3D'rgba(62%2C%20102%2C%2070%2C%201)'%3E%3C%2Frect%3E%3Crect%20x%3D'0'%20y%3D'2'%20width%3D'100%25'%20height%3D'2'%20fill%3D'rgba(52%2C%2086%2C%2059%2C%201)'%3E%3C%2Frect%3E%3C%2Fg%3E%3C%2Fpattern%3E%3C%2Fdefs%3E%3Crect%20x%3D'0'%20y%3D'0'%20width%3D'100%25'%20height%3D'100%25'%20fill%3D'url(%23svg-stripes-pattern-7515)'%3E%3C%2Frect%3E%3C%2Fsvg%3E` +
        `%0A")`
      : `url("data:image/svg+xml,%3Csvg%20id%3D'stripes-svg'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20width%3D'100%25'%20height%3D'100%25'%3E%3Cdefs%3E%3Cpattern%20id%3D'svg-stripes-pattern-7515'%20patternTransform%3D'rotate(45)'%20width%3D'100%25'%20height%3D'4'%20x%3D'0'%20y%3D'0'%20patternUnits%3D'userSpaceOnUse'%3E%3Cg%3E%3Crect%20x%3D'0'%20y%3D'0'%20width%3D'100%25'%20height%3D'2'%20fill%3D'rgba(235%2C%20173%2C%200%2C%201)'%3E%3C%2Frect%3E%3Crect%20x%3D'0'%20y%3D'2'%20width%3D'100%25'%20height%3D'2'%20fill%3D'rgba(225%2C%20163%2C%200%2C%201)'%3E%3C%2Frect%3E%3C%2Fg%3E%3C%2Fpattern%3E%3C%2Fdefs%3E%3Crect%20x%3D'0'%20y%3D'0'%20width%3D'100%25'%20height%3D'100%25'%20fill%3D'url(%23svg-stripes-pattern-7515)'%3E%3C%2Frect%3E%3C%2Fsvg%3E%0A")`;

  const hasBreakdownTime: boolean = !!props.breakdownTimeEnd && props.breakdownTimeEnd > 0;

  return (
    <div
      className="GridGroupEvent absolute select-none shadow bg-forest"
      style={
        {
          ...EVENT_BORDERS('white', hasBreakdownTime),
          backgroundImage,
          ...props.style,
          '--buffer-start': `${props.setUpTimeStart}px`,
          '--buffer-end': `${props.breakdownTimeEnd}px`,
          '--backgroundColor':
            props.groupEvent.status === 'approved'
              ? BACKGROUND_COLOR_APPROVED
              : BACKGROUND_COLOR_MODIFIED,
        } as CSSPropertiesWithVars
      }
    >
      <div className="w-full h-full overflow-hidden text-white" style={{ padding: '4px 4px' }}>
        <div className="text-white font-bold" style={{ fontSize: 10, lineHeight: '10px' }}>
          {getBasicTimeString(props.groupEvent, props.meta.hourFormat)}
        </div>
        <div className="text-white text-xs leading-4">
          {props.groupEvent.group} - {props.groupEvent.title}
        </div>
        <div
          className="absolute bottom-0 right-0 whitespace-nowrap flex justify-center 
            not-italic max-w-full overflow-hidden pointer-events-none border-t border-l border-white"
          style={{ height: 15 }}
        >
          <BubbleBadge
            variant="slate"
            style={{ width: 15, height: 15 }}
            className="p-0-i grid items-center justify-center text-center rounded-0-i"
          >
            <FontAwesomeIcon icon="people-group" />
          </BubbleBadge>
        </div>
      </div>
    </div>
  );
}
export default GridGroupEvent;
